import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { fmtDateBR, whatsappLink } from "@/lib/format";
import { MessageCircle, Clock } from "lucide-react";

const RANGES = [30, 45, 60, 90, 120];

export default function Reativacao() {
  const { studio } = useAuth();
  const [days, setDays] = useState(60);
  const [items, setItems] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [r, t] = await Promise.all([
        api.get("/clients/inactive/list", { params: { days } }),
        api.get("/message-templates"),
      ]);
      setItems(r.data);
      setTemplates(t.data);
      setLoading(false);
    })();
  }, [days]);

  const reativTemplate = templates.find(t => t.category === "reativacao") ||
                         templates.find(t => t.category === "manutencao");

  const buildMessage = (c) => {
    let msg = reativTemplate?.content || `Oi, {nome}! Senti sua falta. Que tal agendar uma manutenção?`;
    return msg
      .replaceAll("{nome}", c.name)
      .replaceAll("{studio}", studio?.name || "")
      .replaceAll("{servico}", c.last_service || "")
      .replaceAll("{data}", "")
      .replaceAll("{hora}", "")
      .replaceAll("{valor}", "")
      .replaceAll("{profissional}", "");
  };

  return (
    <div className="space-y-4" data-testid="reactivation-page">
      <div>
        <h1 className="font-display text-2xl md:text-3xl font-bold text-[#27272A]">Clientes para reativar</h1>
        <p className="text-[#71717A] text-sm mt-1">Clientes que talvez estejam na hora de voltar.</p>
      </div>

      <div className="flex gap-2 overflow-x-auto hide-scrollbar" data-testid="days-filter">
        {RANGES.map(r => (
          <button key={r} onClick={() => setDays(r)} data-testid={`days-${r}`}
            className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold ${days === r ? "bg-[#682F3E] text-white" : "bg-white text-[#71717A] border border-[#E4E4E7]"}`}>
            {r === 120 ? "120+" : r} dias
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-[#71717A] text-sm">Carregando…</div>
      ) : items.length === 0 ? (
        <div className="card-nc p-8 text-center" data-testid="reactivation-empty">
          <p className="text-[#71717A]">Ótimo! Nenhuma cliente sem retornar há {days}+ dias.</p>
        </div>
      ) : (
        <div className="grid gap-2">
          {items.map(c => (
            <div key={c.id} data-testid={`inactive-${c.id}`} className="card-nc p-4 flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-[#F9ECE8] flex items-center justify-center text-[#B76E56] font-bold">
                {c.name.slice(0, 1).toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-[#27272A] truncate">{c.name}</div>
                <div className="text-xs text-[#71717A] flex items-center gap-1 mt-0.5">
                  <Clock size={12} />
                  há {c.days_since} dias · {c.last_service}
                </div>
                <div className="text-[10px] text-[#71717A] mt-0.5">Último: {fmtDateBR(c.last_appointment)}</div>
              </div>
              {(c.whatsapp || c.phone) && (
                <a href={whatsappLink(c.whatsapp || c.phone, buildMessage(c))} target="_blank" rel="noreferrer"
                  data-testid={`wa-inactive-${c.id}`}
                  className="btn-primary-nc py-2 px-3 text-xs flex items-center gap-1">
                  <MessageCircle size={14} /> Chamar
                </a>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
